export default "__VITE_ASSET__CvSfD5bH__"